import type { AlertListQuery } from '@chukua/common';

/** "Unacknowledged" is the status filter set to open alone; other status selections made in the column filter are not it. */
export function isUnacknowledgedOnly(query: Pick<AlertListQuery, 'status'>): boolean {
  return query.status?.length === 1 && query.status[0] === 'open';
}

/** The yes/no filters the table's column filters cannot show, so "is anything filtered?" has to count them too. */
export function isAnyFlagFilterOn(query: Pick<AlertListQuery, 'mine' | 'overdue'>): boolean {
  return query.mine === true || query.overdue === true;
}
